import React, { useState } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";

interface CountrySelectProps {
  onChange?: (country: { label: string; value: string }) => void;
  placeholder?: string;
}

const CountrySelect: React.FC<CountrySelectProps> = ({
  onChange,
  placeholder = "Choisir un pays",
}) => {
  const [value, setValue] = useState<any>(null);
  const options = countryList().getData(); // retourne tous les pays { label, value }

  const changeHandler = (val: any) => {
    setValue(val);
    onChange && onChange(val);
  };

  return (
    <div>
      <Select
        options={options}
        value={value}
        onChange={changeHandler}
        placeholder={placeholder}
      />
      {/*       {value && <p className="mt-2">🌍 Pays choisi : {value.label}</p>}
       */}{" "}
    </div>
  );
};

export default CountrySelect;
